import React, { useEffect, useState } from 'react'
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
} from 'reactflow'
import styles from './index.less'
import type {
  Edge,
  EdgeProps,
} from 'reactflow'
import type { RuleErrorItem } from 'src/utils/basic'

export interface CustomEdgeData {
  edgeName: string
  hasErr: boolean
  errInfo: Array<RuleErrorItem>
  edgeType: 'Condition'
}

export type CustomEdgeType = Edge<CustomEdgeData>

// const setMarkerEnd = (str = "url('#1__')", obj: Record<string, string>) => {
//   // 从字符串中提取查询字符串部分并转换为JSON对象
//   const queryString = str.split('__')[1];
//   const params = queryString.slice(0, queryString.length - 2).split('&');
//   const parsedJson: Record<string, string> = {};

//   params.forEach((param) => {
//     const [key, value] = param.split('=');
//     parsedJson[key] = value;
//   });

//   // 合并传入的JSON对象，覆盖已有的字段
//   const mergedJson = { ...parsedJson, ...obj };

//   // 重新构建带有合并参数的查询字符串
//   const updatedQueryString = Object.keys(mergedJson)
//     .map((key) => `${key}=${mergedJson[key]}`)
//     .join('&');

//   // 构建最终的字符串
//   const result = `url('#1__${updatedQueryString}')`;

//   return result;
// };

export function CustomEdge(props: EdgeProps) {
  const {
    // id,
    data,
    selected,
    // source,
    sourceX,
    sourceY,
    targetX,
    targetY,
    // targetHandleId,
    // sourceHandleId,
    sourcePosition,
    targetPosition,
    style = {},
    markerEnd,
  } = props
  // const [groupInnerNodePath, setGroupInnerNodePath] = useState<string>('');
  const [pathConfig, setPathConfig] = useState<{
    sourceX: number
    sourceY: number
    targetX: number
    targetY: number
  }>({} as any)
  const [edgePath, labelX, labelY] = getBezierPath(pathConfig)
  // console.log('CustomEdge props ===>', props);
  // console.log('markerEnd before ===>', markerEnd);
  // markerEnd = setMarkerEnd(markerEnd!, selected ? { color: '#5582f3' } : data.hasErr ? { color: 'red' } : {});
  // console.log('markerEnd after ===>', markerEnd);
  useEffect(() => {
    // if (sourceHandleId === source + '_innerTop') {
    //   setPathConfig({
    //     sourceX: targetX,
    //     sourceY,
    //     targetX,
    //     targetY,
    //   });
    // } else {
    // setPathConfig({
    //   sourceX,
    //   sourceY,
    //   targetX,
    //   targetY,
    // });
    const path = {
      sourceX,
      sourceY,
      targetX,
      targetY,
    }
    if (sourcePosition === 'bottom') {
      path.sourceY = path.sourceY - 5
    }
    else if (sourcePosition === 'left') {
      path.sourceX = path.sourceX + 5
    }
    else if (sourcePosition === 'right') {
      path.sourceX = path.sourceX - 5
    }

    if (targetPosition === 'top') {
      path.targetY = path.targetY + 5
    }
    setPathConfig(path)
    // }
  }, [targetPosition, sourcePosition, sourceX, sourceY, targetX, targetY])

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          stroke: selected ? '#5582f3' : data.hasErr ? 'red' : '',
          // markerEnd: {
          //   color: selected ? '#5582f3' : data.hasErr ? 'red' : '',
          // },
        }}
      />
      {/* <path id='reactflow__edge-updater-path' style={{ opacity: 0 }} d={edgePath} markerEnd={markerEnd} /> */}

      {
        data.edgeName
          ? (
              <EdgeLabelRenderer>
                <div
                  style={{
                    transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
                    // 文案 错误优先
                    color: data.hasErr ? 'red' : selected ? '#5582F3' : 'black',
                    boxShadow: '0px 4px 10px 2px rgba(0,31,122,0.04)',
                    borderRadius: 4,
                    background: data.edgeName === '' ? 'transparent' : 'white',
                    pointerEvents: 'all',
                  }}
                  className={`${styles.edgeLabel}`}
                  title={
                    data.hasErr
                      ? data.errInfo.reduce(
                        (a: number, item: RuleErrorItem) => a + item.msg,
                        '',
                      )
                      : undefined
                  }
                  // title={data.hasErr ? 'this is error' : undefined}
                >
                  {data.edgeName}
                </div>
              </EdgeLabelRenderer>
            )
          : null
      }
    </>
  )
}
